import { OpenIdConnect } from 'aurelia-open-id-connect';
import { autoinject } from 'aurelia-framework';
import { HttpClient } from "aurelia-fetch-client";
import { AureliaApplicationSettings } from "../../models/aurelia-application-settings";

@autoinject()
export class Login {
    accessToken: string;
    claims: any;
    constructor(private openIdConnect: OpenIdConnect,
        private httpClient: HttpClient,
        private applicationSettings: AureliaApplicationSettings) {

    }

    private login() {
        this.openIdConnect.login();
    }

    private logout() {
        this.openIdConnect.logout();
    }

    private async callApi() {
        const user = await this.openIdConnect.getUser();
        this.accessToken = user.access_token;

        this.httpClient.configure(config => {
            config.withBaseUrl(`${this.applicationSettings.Authority}/`);
            config.withDefaults({
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${this.accessToken}`
                }
            });
        });

        return this.httpClient.get('api/test')
            .then(result => result.json() as Promise<any[]> )
            .then(claims => {
                this.claims = claims;
            })
            .catch(error => {
                var s = error;
            });
    }
}